// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout-11uTSB5I"};